import { reseedSandboxDemoPatients } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';

import { createLotusRequestConfig } from '@/shared/api/lotus';

import type { DemoRoster } from './demoRoster.js';

export async function reseedDemoPatients(slugs: string[]): Promise<DemoRoster> {
  const config = await createLotusRequestConfig();
  const response = await reseedSandboxDemoPatients({ slugs }, config);
  return lotusHealthZod.reseedSandboxDemoPatientsResponse.parse(response.data).roster;
}
